import React from 'react'
import Button from './Button'

function CustomList({title,list,value,setValue,screen,setScreen,searchTerm}) {
  return (
    <div className={`custom-list`} >
      <div className={`custom-list-panel`} >
        {screen>1&& <Button onClick={() => {setScreen(Math.max(1,screen-1))}} title={'Previous'} />}
        <h2 className={`custom-list-title`} >{title} </h2>

      </div>
      <div className={`scroll-area`} >
      {
            Object.values(list)?.map((val) => (
              <p onClick={() => {
                  setValue(val)
                  if(screen<2)
                  setScreen(screen+1)
                }} className={`list-items`} >{val.name} </p>
            ))
        }
      </div>
        
    </div>
  )
}

export default CustomList